import { render } from "./Weather-Policy.vue?vue&type=template&id=2eafa571"
import script from "./Weather-Policy.vue?vue&type=script&lang=js"
export * from "./Weather-Policy.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3192284683/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__